import React from 'react';
import { ScheduleWorker } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import {
  getInitialsForUser,
  getOrganizationName,
  getUserFullName,
} from 'utils';
import { AvatarCell, IconTextCell } from '@odin-labs/components';
import { WrenchIcon } from 'components/icons';

export function ScheduleWorkersTableContractorCell(props: {
  componentProps: ScheduleWorker;
}): React.ReactNode {
  const { componentProps: sw } = props;
  const contractorName = getOrganizationName(
    sw.jobsiteContractor?.contractor?.organization,
  );

  if (sw?.jobsiteWorker) {
    const { worker } = sw.jobsiteWorker.contractorWorker ?? {};
    return (
      <AvatarCell
        componentProps={{
          detail: contractorName,
          objectFit: 'cover',
          placeholder: getInitialsForUser(worker?.user),
          size: 'xs',
          src: worker?.profilePictureCropped?.downloadUrl,
        }}
        value={getUserFullName(worker?.user)}
      />
    );
  }

  return (
    <IconTextCell
      componentProps={{ icon: WrenchIcon, size: 'md' }}
      value={contractorName}
    />
  );
}
